import { HttpClientModule, withInterceptorsFromDi } from '@angular/common/http';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N, pt_BR } from 'ng-zorro-antd/i18n';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { registerLocaleData, PathLocationStrategy, LocationStrategy } from '@angular/common';
import ptBr from '@angular/common/locales/pt';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { NgChartsModule  } from 'ng2-charts';
import { NgApexchartsModule } from "ng-apexcharts";
import { AngularSvgIconModule } from 'angular-svg-icon';

import { AppComponent } from './app.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { ComponentsModule } from 'src/app/shared/components/components.module';

import { ThemeConstantService } from './shared/services/theme-constant.service';
import { AppRequestsInterceptorProvider } from "./shared/interceptors/app-request.interceptor";

import { NgxMaskDirective, provideNgxMask, NgxMaskPipe } from 'ngx-mask';
import {TimeoutInterceptorProvider} from "./shared/interceptors/timeout.interceptor";

import { CustomPaginatorIntl } from './shared/custom-paginator-intl/custom-paginator-intl';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideHttpClient } from '@angular/common/http';

registerLocaleData(ptBr);


@NgModule({
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        FullLayoutComponent,
    ],
    imports: [
        ComponentsModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        NzBreadCrumbModule,
        NzSpinModule,
        NgChartsModule,
        NgApexchartsModule,
        AngularSvgIconModule.forRoot(),
        NgxMaskDirective,
        NgxMaskPipe,
        HttpClientModule
    ],
    providers: [
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        provideNgxMask(),
        {
            provide: NZ_I18N,
            useValue: pt_BR,
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        ThemeConstantService,
        AppRequestsInterceptorProvider,
        TimeoutInterceptorProvider,
        {
          provide: MatPaginatorIntl,
          useClass: CustomPaginatorIntl
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
